import { createPortal } from 'react-dom';

const root = document.getElementById('portal-root');

const Portal = ({ portalRoot = root, children }) => createPortal(children, portalRoot);

export default Portal;
